var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4429 0H25.6C9.25867 0 0 9.25867 0 25.6V70.4002C0 86.7413 9.25867 96 25.6 96H70.4429C86.784 96 96 86.7413 96 70.4002V25.6C96 9.25867 86.784 0 70.4429 0Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 63H78V57H72V63ZM72 33V51H78V33H72ZM45 39H61.5L45 22.5V39ZM24 18H48L66 36V72C66 75.33 63.33 78 60 78H24C20.67 78 18 75.3 18 72V24C18 20.67 20.67 18 24 18ZM51 66V60H24V66H51ZM60 54V48H24V54H60Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCategory);
export default __webpack_public_path__ + "static/media/empty-category.5956545f7b100b0ccc7a94d4b4877ea3.svg";
export { ForwardRef as ReactComponent };